import type { FaireProductEntity } from "../../entity_types/product";

export const p_jefp8tc5sp: FaireProductEntity = {
  token: "p_jefp8tc5sp",
  type: "product",
  name: "de la Paz Peel Sessions blend",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/cc962955d672ff669e1e43428f6a88899d421fb49b38edbc9d1174d7299c244f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00240da7659c660bf4f2e19866bcd7dc9b99384aab32ddefbc5573d37ea3454b.jpeg",
    "https://cdn.faire.com/fastly/ce7d786c2293450403f5bbb042ddd045844d2494727dc2ffe77faba9ebc795ac.jpeg",
    "https://cdn.faire.com/fastly/b65e31ad1ed828f6c78bfee1a606201dc05debffe69ea5adad702ee8781f3148.jpeg"
  ],
  priceDollars: 26,
  description: "honey, rose, strawberry\n\nThis light and bright baby is an unprecedentedly clean and provocative blend. A few daring folks run this Starburst Fruit Chew of a blend as espresso, but most of us savor its savoir faire in a slightly bigger cup. The first blend ever to win a Good Food Award, and still the best.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:59.676Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
